import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DialogComponent from '../dialog/dialog.component';
import { createAmount, fetchBalance } from '../../api';
import payment from '../../images/profile/payment.png';
import { InputWarning } from '../inputwarning/input-warning.component';
import { TrapeziumButton } from '../buton-trapezium';
import { useConsentGate } from '../../hooks/use-consent-gate';
import { useTopupPricing } from '../../hooks/useTopupPricing';

const DialogPayment = (props) => {
  const { onConfirm, onCancel } = props;
  const topupGate = useConsentGate('wallet-topup');
  const [amount, setAmount] = useState(0);
  const [balance, setBalance] = useState(0);
  const [open, setOpen] = useState(false);
  const [paying, setPaying] = useState(false); // QA S-27: chống double-submit nạp tiền
  const handleAmountClick = (value) => {
    setAmount(value);
  };
  // Tỉ giá + phí cổng đọc từ cấu hình đang chạy (useTopupPricing khớp đúng công thức BE).
  // Trước đây ba con số này bị hard-code ở FE, admin đổi trong Settings là FE hiện sai ngay.
  const pricing = useTopupPricing();
  const vndToCa = (vnd: number) => pricing.caFor(vnd);
  const formatCa = (value: number) => `${Number(value).toLocaleString('vi-VN')} ca`;
  const formatVnd = (value: number) => `${Number(value).toLocaleString('vi-VN')}đ`;
  const gatewayFee = (base: number) => pricing.feeVnd(base);
  const totalPay = (base: number) => pricing.chargeVnd(base);
  // Chặn ngay ở FE thay vì để cổng trả 400 sau khi người dùng đã bấm xác nhận.
  const belowMin = amount > 0 && amount < pricing.minVnd;
  const aboveMax = pricing.maxVnd > 0 && amount > pricing.maxVnd;
  const handleClose = () => {
    setOpen(false);
  };
  const handleAmount = () => {
    if (amount > 0 && !paying && !belowMin && !aboveMax) {
      setPaying(true); // QA S-27
      createAmount(amount)
        .then((res) => {
          window.location.href = res.paymentUrl;
        })
        .catch(() => {
          setPaying(false); // lỗi mới cho bấm lại (thành công đã redirect)
        });
    }
  };
  useEffect(() => {
    fetchBalance().then((res) => {
      setBalance(res.balance);
    });
  }, []);

  return (
    <>
      <TrapeziumButton onClick={() => setOpen(true)}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.88169 17.7056C7.4208 17.1664 7.7305 16.478 7.8108 15.7668C7.91977 14.8203 7.60433 13.8394 6.88169 13.1167C6.45155 12.6865 5.9239 12.3997 5.36759 12.2678C4.30657 11.9982 3.13085 12.2792 2.2935 13.1167C1.71424 13.696 1.39881 14.436 1.35866 15.1989C1.32998 15.5259 1.35866 15.8643 1.44469 16.1912C1.5766 16.7476 1.86336 17.2754 2.2935 17.7056C3.56099 18.9732 5.6142 18.9732 6.88169 17.7056ZM5.80346 14.8146C6.13611 14.8146 6.4114 15.0899 6.4114 15.4226C6.40566 15.761 6.13611 16.0306 5.79773 16.0364L5.19553 16.0306L5.20126 16.61C5.19553 16.9484 4.92597 17.218 4.58759 17.2237C4.24922 17.218 3.97966 16.9484 3.97393 16.61L3.97966 16.0306L3.37746 16.0364C3.03908 16.0306 2.76953 15.761 2.76379 15.4226C2.76953 15.2563 2.83835 15.1071 2.94732 14.9981C3.05629 14.8891 3.2054 14.8203 3.37173 14.8146L3.97966 14.8146L3.97966 14.1836C3.97966 14.0115 4.04848 13.8624 4.15745 13.7534C4.26642 13.6444 4.41554 13.5756 4.58759 13.5756C4.92024 13.5756 5.19553 13.8509 5.19553 14.1836L5.19553 14.8146L5.80346 14.8146Z"
            fill="white"
          />
          <path
            d="M12.5794 3.20535V6.28793H11.3628V3.20535C11.3628 2.98633 11.1681 2.88087 11.0383 2.88087C10.9978 2.88087 10.9572 2.88898 10.9167 2.90521L4.48477 5.33071C4.0549 5.49295 3.77913 5.89855 3.77913 6.36094V6.90444C3.04104 7.45606 2.5625 8.34028 2.5625 9.33806V6.36094C2.5625 5.3956 3.15459 4.53573 4.0549 4.19502L10.4949 1.76141C10.6733 1.69651 10.8599 1.66406 11.0383 1.66406C11.8494 1.66406 12.5794 2.32114 12.5794 3.20535Z"
            fill="white"
          />
          <path
            d="M17.9741 11.764V12.5752C17.9741 12.7942 17.8037 12.9727 17.5766 12.9808H16.3925C15.9626 12.9808 15.5733 12.6644 15.5408 12.2426C15.5165 11.9911 15.6138 11.7559 15.776 11.5936C15.922 11.4395 16.1248 11.3584 16.3438 11.3584H17.5685C17.8037 11.3665 17.9741 11.545 17.9741 11.764Z"
            fill="white"
          />
          <path
            d="M16.3347 10.5054H17.162C17.6081 10.5054 17.9731 10.1403 17.9731 9.69417V9.33724C17.9731 7.65805 16.6024 6.28711 14.9234 6.28711H5.61218C4.92276 6.28711 4.29011 6.51425 3.77913 6.90363C3.04104 7.45524 2.5625 8.33946 2.5625 9.33724V10.7812C2.5625 11.0894 2.88693 11.2841 3.17892 11.1868C3.63313 11.0327 4.11167 10.9515 4.59021 10.9515C7.0478 10.9515 9.05118 12.9552 9.05118 15.4132C9.05118 15.9972 8.89707 16.6381 8.65374 17.2059C8.52397 17.498 8.72674 17.8468 9.04306 17.8468H14.9234C16.6024 17.8468 17.9731 16.4758 17.9731 14.7966V14.6425C17.9731 14.1964 17.6081 13.8313 17.162 13.8313H16.4564C15.6777 13.8313 14.9315 13.3527 14.7288 12.5983C14.5666 11.9818 14.7612 11.3815 15.1668 10.9921C15.4669 10.6838 15.8805 10.5054 16.3347 10.5054ZM11.89 10.3431H7.83455C7.502 10.3431 7.22624 10.0673 7.22624 9.73473C7.22624 9.40214 7.502 9.12633 7.83455 9.12633H11.89C12.2225 9.12633 12.4983 9.40214 12.4983 9.73473C12.4983 10.0673 12.2225 10.3431 11.89 10.3431Z"
            fill="white"
          />
        </svg>
        <span className="skew-x-[20deg]">Nạp số dư</span>
      </TrapeziumButton>

      <DialogComponent
        onClose={() => handleClose()}
        visible={open}
        placement="CENTER"
        title="Nạp số dư vào tài khoản"
        size="xl"
      >
        <div className="flex flex-col gap-3 ">
          <p className="text-xs text-slate-500 px-1 -mt-1">
            “Ca” là điểm tiện ích nội bộ dùng trong Cab, không phải tiền tệ và không có
            giá trị lưu thông ngoài hệ thống.
          </p>
          <div className="w-full h-12 flex justify-between px-5 items-center bg-[#ebecf2]">
            <span className="text-sm text-[#111827]  font-semibold">
              Số Ca hiện tại
            </span>
            <div className="flex items-center gap-1">
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.5 12L12.5 4"
                  stroke="#26B35E"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 4H12.5V10.5"
                  stroke="#26B35E"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <span className="text-sm font-medium uppercase text-[#26B35E]">
                {formatCa(balance)}
              </span>
            </div>
          </div>
          <div className="gap-5 flex flex-col p-6">
            <div className="grid grid-cols-3 gap-6">
              {[20000, 50000, 100000, 200000, 500000, 1000000].map((value) => (
                <div
                  key={value}
                  className={`p-4 border border-[#E5E7EB] dark:border-slate-700 aspect-[200/182] max-w-[200px] rounded-2xl cursor-pointer flex justify-center flex-col gap-2 font-bold ${
                    amount === value &&
                    'bg-[linear-gradient(to_top,#DBE8FB,#F3F7FB)] border-transparent '
                  }`}
                  onClick={() => handleAmountClick(value)}
                >
                  <div className="flex  items-center j  ustify-center flex-col">
                    <img
                      className="w-[94px] aspect-square"
                      src={payment}
                      alt="amount"
                    />
                    <p>{formatCa(vndToCa(value))}</p>
                    <span className="text-xs font-medium text-[#0071A6]">
                      Thanh toán {formatVnd(totalPay(value))}
                    </span>
                  </div>
                </div>
              ))}
            </div>
            <div>
              <label className=" flex items-center  text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Nhập số tiền khác &nbsp;
                <InputWarning />
              </label>
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(Number(e.target.value))}
                className="mt-1 block w-full p-3 text-base rounded-lg bg-white dark:bg-slate-800 border border-gray-300 dark:border-gray-600 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-[#18191E] sm:text-sm dark:text-white"
                required
                placeholder="0đ"
              />
            </div>

            {(belowMin || aboveMax) && (
              <p className="text-sm font-medium text-[#F04438]">
                {belowMin
                  ? `Số tiền nạp tối thiểu là ${formatVnd(pricing.minVnd)}.`
                  : `Số tiền nạp tối đa là ${formatVnd(pricing.maxVnd)}.`}
              </p>
            )}

            {amount > 0 && (
              <div className="rounded-xl bg-[#F6F7F8] p-4 text-sm flex flex-col gap-1.5">
                <div className="flex justify-between text-[#62677D]">
                  <span>Mệnh giá gốc (1 ca = {formatVnd(pricing.vndPerCa)})</span>
                  <span className="text-[#18191E]">{formatVnd(amount)}</span>
                </div>
                <div className="flex justify-between text-[#62677D]">
                  <span>Phí cổng thanh toán ({pricing.feeLabel})</span>
                  <span>+ {formatVnd(gatewayFee(amount))}</span>
                </div>
                <div className="flex justify-between border-t border-[#DEE0E6] dark:border-slate-700 pt-1.5 mt-0.5 font-semibold">
                  <span className="text-[#18191E]">Tổng thanh toán</span>
                  <span className="text-[#F04438]">{formatVnd(totalPay(amount))}</span>
                </div>
                <div className="flex justify-between font-semibold text-[#0071A6]">
                  <span>Bạn nhận</span>
                  <span>{formatCa(vndToCa(amount))}</span>
                </div>
              </div>
            )}
          </div>
          <div className="flex justify-end p-6 border-t border-t-[#DEE0E6] dark:border-t-slate-700 gap-4">
            <button
              className="bg-white border border-[#DEE0E6] dark:border-slate-700 text-base font-semibold h-10 flex items-center justify-center px-4 py-2 rounded-lg text-black"
              // Mọi nơi dùng truyền onCancel rỗng nên nút không làm gì; tự đóng hộp rồi mới báo ra ngoài.
              onClick={() => {
                handleClose();
                onCancel?.();
              }}
            >
              Hủy bỏ
            </button>
            <TrapeziumButton
              onClick={() => topupGate.run(handleAmount)}
              disabled={amount <= 0 || paying || belowMin || aboveMax}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.88169 17.7056C7.4208 17.1664 7.7305 16.478 7.8108 15.7668C7.91977 14.8203 7.60433 13.8394 6.88169 13.1167C6.45155 12.6865 5.9239 12.3997 5.36759 12.2678C4.30657 11.9982 3.13085 12.2792 2.2935 13.1167C1.71424 13.696 1.39881 14.436 1.35866 15.1989C1.32998 15.5259 1.35866 15.8643 1.44469 16.1912C1.5766 16.7476 1.86336 17.2754 2.2935 17.7056C3.56099 18.9732 5.6142 18.9732 6.88169 17.7056ZM5.80346 14.8146C6.13611 14.8146 6.4114 15.0899 6.4114 15.4226C6.40566 15.761 6.13611 16.0306 5.79773 16.0364L5.19553 16.0306L5.20126 16.61C5.19553 16.9484 4.92597 17.218 4.58759 17.2237C4.24922 17.218 3.97966 16.9484 3.97393 16.61L3.97966 16.0306L3.37746 16.0364C3.03908 16.0306 2.76953 15.761 2.76379 15.4226C2.76953 15.2563 2.83835 15.1071 2.94732 14.9981C3.05629 14.8891 3.2054 14.8203 3.37173 14.8146L3.97966 14.8146L3.97966 14.1836C3.97966 14.0115 4.04848 13.8624 4.15745 13.7534C4.26642 13.6444 4.41554 13.5756 4.58759 13.5756C4.92024 13.5756 5.19553 13.8509 5.19553 14.1836L5.19553 14.8146L5.80346 14.8146Z"
                  fill="white"
                />
                <path
                  d="M12.5794 3.20535V6.28793H11.3628V3.20535C11.3628 2.98633 11.1681 2.88087 11.0383 2.88087C10.9978 2.88087 10.9572 2.88898 10.9167 2.90521L4.48477 5.33071C4.0549 5.49295 3.77913 5.89855 3.77913 6.36094V6.90444C3.04104 7.45606 2.5625 8.34028 2.5625 9.33806V6.36094C2.5625 5.3956 3.15459 4.53573 4.0549 4.19502L10.4949 1.76141C10.6733 1.69651 10.8599 1.66406 11.0383 1.66406C11.8494 1.66406 12.5794 2.32114 12.5794 3.20535Z"
                  fill="white"
                />
                <path
                  d="M17.9741 11.764V12.5752C17.9741 12.7942 17.8037 12.9727 17.5766 12.9808H16.3925C15.9626 12.9808 15.5733 12.6644 15.5408 12.2426C15.5165 11.9911 15.6138 11.7559 15.776 11.5936C15.922 11.4395 16.1248 11.3584 16.3438 11.3584H17.5685C17.8037 11.3665 17.9741 11.545 17.9741 11.764Z"
                  fill="white"
                />
                <path
                  d="M16.3347 10.5054H17.162C17.6081 10.5054 17.9731 10.1403 17.9731 9.69417V9.33724C17.9731 7.65805 16.6024 6.28711 14.9234 6.28711H5.61218C4.92276 6.28711 4.29011 6.51425 3.77913 6.90363C3.04104 7.45524 2.5625 8.33946 2.5625 9.33724V10.7812C2.5625 11.0894 2.88693 11.2841 3.17892 11.1868C3.63313 11.0327 4.11167 10.9515 4.59021 10.9515C7.0478 10.9515 9.05118 12.9552 9.05118 15.4132C9.05118 15.9972 8.89707 16.6381 8.65374 17.2059C8.52397 17.498 8.72674 17.8468 9.04306 17.8468H14.9234C16.6024 17.8468 17.9731 16.4758 17.9731 14.7966V14.6425C17.9731 14.1964 17.6081 13.8313 17.162 13.8313H16.4564C15.6777 13.8313 14.9315 13.3527 14.7288 12.5983C14.5666 11.9818 14.7612 11.3815 15.1668 10.9921C15.4669 10.6838 15.8805 10.5054 16.3347 10.5054ZM11.89 10.3431H7.83455C7.502 10.3431 7.22624 10.0673 7.22624 9.73473C7.22624 9.40214 7.502 9.12633 7.83455 9.12633H11.89C12.2225 9.12633 12.4983 9.40214 12.4983 9.73473C12.4983 10.0673 12.2225 10.3431 11.89 10.3431Z"
                  fill="white"
                />
              </svg>
              <span className="skew-x-[20deg]">Nạp số dư</span>
            </TrapeziumButton>
          </div>
        </div>
      </DialogComponent>
      {topupGate.modal}
    </>
  );
};

DialogPayment.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default DialogPayment;
